export function nullifyObjectUndefinedValues(obj: Record<string, unknown>) {
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value == 'undefined') {
      obj[key] = null;
    }
  }
  return obj;
}
